import React from "react"
import { useConfig } from "../utils/use-config"

type Props = {
  text: string
  disabled?: boolean
}

const SubmitButton: React.FC<Props> = ({ text, disabled }) => {
  const { styles } = useConfig()
  return (
    <button
      type="submit"
      disabled={disabled}
      className="hw-mt-4 hw-inline-flex hw-items-center hw-px-4 hw-py-2 hw-border hw-border-transparent hw-text-sm hw-font-medium hw-rounded-md hw-shadow-sm hw-text-white hw-bg-indigo-600 focus:hw-outline-none focus:hw-ring-2 focus:hw-ring-offset-2 focus:hw-ring-indigo-500"
      style={{ backgroundColor: styles?.buttonBgColor, color: styles?.buttonTextColor }}
    >
      {text}
    </button>
  )
}

export default SubmitButton
